import { ElementType, FC } from 'react';
import Icon from '../Icon';
import Opportunity from '../types/Opportunity';
import cn from '../Utils/cn';
import Link from 'next/link';
import Image from 'next/image';
import { SecondaryButton } from '../Buttons/GeneralButtons';

type Props = {
	as?: ElementType;
	className?: string;
	href?: string;
	companyLogo?: string;
} & Opportunity;

const degreeMap = {
	'Doutorado Completo': 'Doutorado Completo',
	'Doutorado Incompleto': 'Doutorado Incompleto',
	'Mestrado Completo': 'Mestrado Completo',
	'Mestrado Incompleto': 'Mestrado Incompleto',
	'Pós-Graduação Completa': 'Pós-Graduação Completa',
	'Pós-Graduação Incompleta': 'Pós-Graduação Incompleta',
	'Ensino Superior Completo': 'Ens. Superior Completo',
	'Ensino Superior Incompleto': 'Ens. Superior Incompleto',
	'Ensino Técnico Completo': 'Ens. Técnico Completo',
	'Ensino Técnico Incompleto': 'Ens. Técnico Incompleto',
	'Ensino Médio Completo': 'Ens. Médio Completo',
	'Ensino Médio Incompleto': 'Ens. Médio Incompleto',
	'Ensino Fundamental Completo': 'Ens. Fund. Completo',
	'Ensino Fundamental Incompleto': 'Ens. Fund. Incompleto',
};

const formatter = new Intl.NumberFormat('pt-BR', {
	style: 'currency',
	currency: 'BRL',
});

const OpportunityCard: FC<Props> = ({ cod, jobTitle, city, salary = null, edRequirement, sector, as: Tag = 'div', href, className, companyLogo }) => {
	return (
		<Link
			href={href || '/'}
			className={cn(
				'w-full',
				'flex flex-col items-start gap-6 sm:gap-8 lg:gap-10 px-4 sm:px-6 py-4 sm:py-6 group',
				'bg-white rounded-2xl text-base-grey-5', 
				'border-[1px] border-solid border-transparent hover:border-brand-main transition-all duration-500 ease-in-out',
				className,
			)}
			aria-label="vaga de emprego"
			role="button"
		>
			<div className="flex flex-col lg:flex-row-reverse w-full gap-8">
				{companyLogo && (
					<Image src={companyLogo} alt="logo" width={100} height={100} className="w- h-40 rounded-2xl object-contain border border-solid border-base-grey-2 p-2 bg-white" />
				)}
				<div className='flex flex-col mr-auto'>

					<p className="text-xs text-brand-main font-bold" aria-label="identificador numérico da vaga">
						#{cod}
					</p>

					<p className="text-lg sm:text-xl lg:text-2xl xl:text-3xl font-bold mt-2 sm:mt-3 font-inter leading-tight">{jobTitle}</p>

					<ul className="flex flex-wrap gap-2 sm:gap-3 mt-6 sm:mt-8 lg:mt-12 mb-6 sm:mb-8 lg:mb-12">
						<li className="px-3 sm:px-4 md:px-5 py-2 sm:py-2 md:py-3 flex gap-1 sm:gap-2 items-center text-sm sm:text-base lg:text-lg leading-none font-bold text-base-grey-5 bg-base-grey-2 rounded-full">
							<Icon name="location" className="text-xs sm:text-sm text-brand-main" /> {city ?? 'Remoto'}
						</li>
						{sector && (
							<li className="px-3 sm:px-4 md:px-5 py-2 sm:py-2 md:py-3 flex gap-1 sm:gap-2 items-center text-sm sm:text-base lg:text-lg leading-none font-bold text-base-grey-5 bg-base-grey-2 rounded-full">
								<Icon name="package" className="text-xs sm:text-sm text-brand-main" /> {sector}
							</li>
						)}

						<li className="px-3 sm:px-4 md:px-5 py-2 sm:py-2 md:py-3 flex gap-1 sm:gap-2 items-center text-sm sm:text-base lg:text-lg leading-none font-bold text-base-grey-5 bg-base-grey-2 rounded-full">
							<Icon name="schooling" className="text-xs sm:text-sm text-brand-main" /> {degreeMap[`${edRequirement}` as keyof typeof degreeMap] ?? edRequirement}
						</li>
						<li className="px-3 sm:px-4 md:px-5 py-2 sm:py-2 md:py-3 flex gap-1 sm:gap-2 items-center text-sm sm:text-base lg:text-lg leading-none font-bold text-base-grey-5 bg-base-grey-2 rounded-full">
							<Icon name="disability" className="text-xs sm:text-sm text-brand-main" /> Vaga PCD
						</li>
					</ul>
				</div>
			</div>
			<div className="mt-auto w-full flex justify-between items-end">
				{/* {salary ? (
						<p className="text-lg leading-none">
							<span className="block text-[1.8rem] text-brand-main font-bold mb-2">Salário</span>
							{typeof salary === 'number' ? formatter.format(salary) : salary ?? 'Não informado'}
						</p>
					) : ( */}
				<p></p>
				{/* )} */}
				<button className="border border-1 border-brand-main text-brand-main hover:bg-brand-main hover:text-white transition-all rounded-full w-full text-sm sm:text-base font-bold p-3 sm:p-4">
					Ver detalhes
				</button>
				{/* <span className="inline-block p-3 text-brand-main border border-solid border-current rounded-xl" aria-label="link da vaga">
					<Icon name="right-angle" className="text-lg" />
				</span> */}
			</div>
		</Link>
	);
};

export default OpportunityCard;
